
import React, { Component } from 'react'

class Footer extends Component {
  render () {
    return (
      <footer className='application-footer'>
        <div className='container'>
          <p>お問い合わせ先</p>
          <div className='disclaimer'>
            <p>Email: info@nihonkatawaku.or.jp</p>
            <p>メールでのお問い合わせのみ受付させていただいております。</p>
            <p>Copyright ©  一般社団法人　日本型枠工事業協会</p>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/common/component/Footer.js